import { IAction } from '@app/shared/interfaces/action.interface';
import { IDropdownOption } from '@app/shared/interfaces/dropdown-option';

export const userActionItems: IAction[] = [
  {
    icon: 'edit',
    label: 'string.edit',
    action: 'openUserForm',
    permissionKey: 'USER_EDIT',
    dataCy: 'user-action-icon-edit',
  },
  {
    icon: 'archive',
    label: 'string.deactivate',
    action: 'toggleUserActivation',
    permissionKey: 'USER_EDIT',
    outlined: true,
    disabledBtnTooltipPosition: 'right',
    dataCy: 'user-action-icon-deactivate',
  },
];

export const userLanguages: IDropdownOption[] = [
  {
    value: 'en-US',
    label: 'English (US)',
  },
  {
    value: 'en-GB',
    label: 'English (UK)',
  },
  {
    value: 'da-DK',
    label: 'Danish',
  },
  {
    value: 'en-EU',
    label: 'English (EU)',
  },
  {
    value: 'fr-FR',
    label: 'French (FR)',
  },
  {
    value: 'es-ES',
    label: 'Spanish (ES)',
  },
];

export const defaultUserLanguage = 'en-US';
export const userAllowedLangs = ['en', 'es', 'fr'];
export const gridsLocalizationMessages = {
  ...require('devextreme/localization/messages/es.json'),
  ...require('devextreme/localization/messages/en.json'),
  ...require('devextreme/localization/messages/fr.json'),
};
